define(['angular'], function(angular) {


    /**
     * @class commissionService
     */
    function CommissionService(pricesService, orderService, boulangerieService) {
        var self = this;

        // Consts: commissions types: unitary prices to be multiplied by quantity or % of a price.
        var COMMISSIONS_TABACPRESSE = {
            sale: {
                till: {
                    customer: {
                        BT: 100,
                        'BT+': 150
                    },
                    prospect: {
                        BT: 200,
                        'BT+': 300
                    }
                }
            },
            installation: {
                till: {
                    // Margin %
                    customer: 0.02,
                    prospect: 0.04
                },
                scanup: 50
            }
        };

        var COMMISSIONS_BOULANGERIE = {
            sale: {
                till: {
                    BT: 150,
                    'BT+': 300
                }
            }
        };

        function getCommissionObject(marketCode) {
            return marketCode === 'TABACPRESSE'
                ? COMMISSIONS_TABACPRESSE
                : marketCode === 'BOULANGERIE'
                    ? COMMISSIONS_BOULANGERIE
                    : {};
        }

        function getCustomerType(scenarioTypeCode) {
            return scenarioTypeCode === 'CONQUETE' ? 'prospect' : 'customer';
        }

        /**
         * Commissions for SCANUP options
         * @param  {Object} order
         * @param  {Object} commissions Commisions object coming from this service
         * @return {Number}            Total amount
         */
        function getOptionsCommission(order, commissions) {
            var nbScanup = order.options
                .filter(function(option) {
                    return option.isScanupDevice && option.optionType.code === 'SCANUP';
                })
                .reduce(function(acc, option) {
                    return acc + option.nbOptions;
                }, 0);

            return commissions.installation.scanup * nbScanup;
        }

        /**
         * Business logic to apply to calculate commissions according to a given order.
         * @param  {Object} order
         * @return {Number} total
         */
        self.getCommissions = function getCommissions(order) {
            var commsObject = getCommissionObject(order.marketType.code);
            var total = { sale: 0, installation: 0 };
            var nbTills = orderService.getNbTills(order.tills);
            if (nbTills > 0) {
                var type = orderService.areTillsMixed(order.tills).tillType.code;
            }

            if (order.marketType.code === 'BOULANGERIE') {
                if (nbTills > 0) {
                    total.sale += commsObject.sale.till[type] * nbTills;
                }
                total.sale += order.prices.packBoulangerie * 2; // Commision = 2 times the monthly price of the pack
            }

            if (order.marketType.code === 'TABACPRESSE' || order.marketType.code === 'AUTRE') {
                total.installation += getOptionsCommission(order, commsObject);
                if (nbTills > 0) {
                    total.sale +=
                        commsObject.sale.till[getCustomerType(order.contract.scenarioType.code)][type] * nbTills;
                    total.installation +=
                        commsObject.installation.till[getCustomerType(order.contract.scenarioType.code)] *
                        pricesService.calculateMargin(order);
                }
            }
            return total;
        };

        return self;
    }

    CommissionService.$inject = ['pricesService', 'orderService', 'boulangerieService'];

    angular.module('app.bdc.common.commissionService', []).factory('commissionService', CommissionService);
});
